import { t } from "@lingui/macro";
import type { PaletteFamily, TemplateColorRole } from "@reactive-resume/schema";

export const getColorLabels = (): Record<TemplateColorRole, string> => ({
  accent: t`Couleur principale`,
  secondaryAccent: t`Accent secondaire`,
  thirdAccent: t`Accent tertiaire`,
  fourthAccent: t`Accent complémentaire`,
  paper: t`Fond de page`,
  sidebar: t`Fond de colonne`,
  panel: t`Encadrés`,
  band: t`Bandeau`,
  name: t`Nom`,
  heading: t`Titres de rubrique`,
  itemTitle: t`Titres des éléments`,
  text: t`Texte principal`,
  secondaryText: t`Texte secondaire`,
  sidebarText: t`Texte de colonne`,
  lightText: t`Texte clair`,
  lightDetails: t`Détails clairs`,
  date: t`Dates`,
  line: t`Filets`,
  sidebarLine: t`Filets de colonne`,
  divider: t`Séparateurs`,
  timeline: t`Frise chronologique`,
  frame: t`Cadre`,
  ring: t`Contours`,
  track: t`Jauges vides`,
  badge: t`Pastilles`,
  sidebarBadge: t`Pastilles de colonne`,
  bullet: t`Puces`,
  dots: t`Points décoratifs`,
  icon: t`Icônes`,
  circle: t`Cercle décoratif`,
  wave: t`Vagues`,
  decoration: t`Décoration`,
  detail: t`Détail`,
});

export const getPaletteLabels = (): Record<PaletteFamily, string> => ({
  ocean: t`Océan`,
  forest: t`Forêt`,
  terracotta: t`Terracotta`,
  plum: t`Prune`,
  indigo: t`Indigo`,
  slate: t`Ardoise`,
});
